<template>
    <div class="enquiry-view" v-loading="loading">
        <div class="row">
            <div class="col-md-12 mb-2">
                
                <el-form ref="switchOption" :model="switchOption" label-width="150px" v-if="rights.switch">
                    <el-form-item label="Testimonial :">
                        <el-switch
                            v-model="switchOption.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="Enable"
                            inactive-text="Disable"
                            @change= "changeDisplayStatus"
                            :disabled = "switchOption.disabled">
                        </el-switch>
                    </el-form-item>
                </el-form>

            </div>
        </div>
        <div class="row" v-if="rights.view">
            <div class="col-md-2 mb-2">
                <el-button type="primary" @click="exportDialog = true">Export to Excel</el-button>

                <el-dialog
                    title="Export Data"
                    :visible.sync="exportDialog"
                    width="50%"
                    :before-close="handleDialogClose"
                    v-loading="exportLoading">
                    <span>
                        <div class="row">
                            <div class="col-md-12 mb-2">
                                <el-date-picker
                                    v-model="dateRangeExport"
                                    type="daterange"
                                    range-separator="To"
                                    start-placeholder="Start date"
                                    end-placeholder="End date"
                                    @change="downloadBtnLoading = false"
                                    format="dd/MM/yyyy">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12" >
                                <el-button :loading="downloadBtnLoading" @click = "exportData">Download</el-button>
                            </div>
                        </div>
                    </span>
                </el-dialog>
            </div>
            <div class="col-md-6 mb-2">
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    @change="handleDateChange"
                    format="dd/MM/yyyy">
                </el-date-picker>
            </div>
            <div class="col-md-4 mb-2">
                <el-input v-model="search" placeholder="Search Transaction ID" />
            </div>
        </div>
        <div class="row" v-if="rights.view">
            <div class="col-md-12 mb-2">
                <el-table
                    :data="tableData.filter(data => !search || data.transaction_id.toLowerCase().includes(search.toLowerCase()))"
                    :default-sort = "{prop: 'enquiry_date', order: 'descending'}"
                    style="width: 100%"
                    v-loading="loading">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Address: {{ props.row.address }}</p>
                            <p>Qualification: {{ props.row.qualification}}</p>
                            <p>Occupation: {{ props.row.occupation}}</p>
                            <p>Gender: {{ genderData[props.row.gender]}}</p>
                            <p>Marital Status: {{ maritalStatusData[props.row.marital_status]}}</p>
                            <p>Transaction Number: {{ props.row.transaction_id}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Name" prop="name" sortable> </el-table-column>
                    <el-table-column label="Age" prop="age"> </el-table-column>
                    <el-table-column label="Email" prop="email"> </el-table-column>
                    <el-table-column label="Mobile" prop="mobile"> </el-table-column>
                    <el-table-column label="Course" prop="course"> </el-table-column>
                    <el-table-column label="Enquiry Date" prop="created_at" sortable> </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="row" v-if="rights.view">
            <div class="col-md-12">
                <div class="block" style="text-align:center">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[100, 200, 500]"
                    :page-size="perPageItem"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalData">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {generateHeader , maritalStatusData , genderData} from "@/misc/function.js";
    export default {
        data() {
            return {
                loading: false,
                rights: {
                    page: true,
                    switch: false,
                    view:false,
                },
                switchOption: {
                    disabled: false,
                    status: true,
                    cs_id: 0
                },
                loading: false,
                exportDialog: false,
                downloadBtnLoading: true,
                exportLoading: false,
                dateRangeExport: '',
                exportDatas: [],
                dateRange: '',
                currentPage: 1,
                perPageItem: 100,
                totalData: 0,
                fromDate: '',
                toDate: '',
                tableData: [],
                search: '',
                //externak function
                maritalStatusData: maritalStatusData(),
                genderData: genderData()
            }
        },
        methods: {
            init() {
                var d = new Date();
                var date;
                date = String(d.getFullYear())+'-'+String(d.getMonth() + 1)+'-'+String(d.getDate());
                this.toDate = date;
                this.fromDate = date;
                this.getRights()
                // this.getData()
            },
            handleDialogClose(done) {
                this.$confirm('Are you sure to close this dialog?')
                .then(_ => {
                    done();
                })
                .catch(_ => {});
            },
            handleSizeChange(val) {
                this.perPageItem = val
                this.getData()
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.getData()
            },
            convertDate(str) {
                var date = new Date(str),
                    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                    day = ("0" + date.getDate()).slice(-2);
                return [date.getFullYear(), mnth, day].join("-");
            },
            handleDateChange(){
                this.fromDate = this.convertDate(this.dateRange[0])
                this.toDate = this.convertDate(this.dateRange[1])
                this.getData()
            },
            getRights() {
                this.loading = true
                this.$axios.post('online-application/rights.php' , {} , {
                    headers: generateHeader("onlineApplicationRight")
                })
                .then((response) => {
                    if(response.data.code == "200"){
                        //Whole Page Right
                        this.rights.page = response.data.body.rights.online_application_page == 1 ? true : false
                        // Rights
                        this.rights.view = response.data.body.rights.online_application_view == 1 ? true : false
                        this.rights.switch = response.data.body.rights.online_application_switch == 1 ? true : false

                        // switchOption Value
                        this.switchOption.status = response.data.body.switchValue.status == 1 ? true : false
                        this.switchOption.cs_id = response.data.body.switchValue.cs_id

                        if(this.rights.view){
                            this.getData();
                        }
                    }
                    else if(response.data.code == "403"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        this.$router.push('/admin/dashboard')
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.loading = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                    this.loading = false
                })
            },
            //Main Display
            //Content Display Setting using switch
            changeDisplayStatus(){
                this.$axios.post('online-application/displaySwitch.php' , {
                    status: this.switchOption.status,
                    cs_id: this.switchOption.cs_id
                }, {
                    headers: generateHeader("onlineApplicationSwitch")
                })
                .then((response) => {
                    if(response.data.code == "204"){
                        this.switchOption.disabled = true
                        setTimeout(() => this.switchOption.disabled = false, 1000);
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            },
            exportData(){
                this.exportLoading = true

                this.$axios.post('online-application/get.php' , {
                    fromDate: this.convertDate(this.dateRangeExport[0]),
                    toDate: this.convertDate(this.dateRangeExport[1]),
                    pageSize: 0,
                    page: 0
                },{
                    headers: generateHeader("onlineApplicationData")
                })
                .then((response) => {
                    if(response.data.code == "200"){
                        this.exportDatas = response.data.body
                        this.handleDownloadXLSX()
                    }
                    else if(response.data.code == "404"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.exportLoading = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                    this.exportLoading = false
                })
            },
            getData(){
                this.loading = true
                this.$axios.post('online-application/get.php' , {
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    pageSize: this.perPageItem,
                    page: this.currentPage
                },{
                    headers: generateHeader("onlineApplicationData")
                })
                .then((response) => {
                    if(response.data.code == "200"){
                        this.tableData = response.data.body
                        this.totalData = parseInt(response.data.extra.totalData)
                    }
                    else if(response.data.code == "404"){
                        this.tableData = []
                        this.totalData = 0
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.loading = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                    this.loading = false
                })
            },
            //Handle Export Function
            handleDownloadXLSX: function (){
                import('@/vendor/Export2Excel').then(excel => {
                    const tHeader = ['Name' , 'Age' , 'Email' , 'Mobile' , 'Address' , 'Qualififcation' , 'Occupation' , 'Gender' , 'Marital Status' , 'Course' , 'Transaction Number' , 'Enquiry Date']
                    const filterVal = ['name' , 'age' , 'email' , 'mobile' , 'address' , 'qualification' , 'occupation' , 'gender' , 'marital_status' , 'course' , 'transaction_id' , 'created_at']
                    const list = this.exportDatas
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: "Enquiry-Data",
                        autoWidth: true,
                        bookType: "xlsx"
                    })
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    if (j === 'timestamp') {
                    return parseTime(v[j])
                    } else {
                    return v[j]
                    }
                }))
            }
        },
        mounted() {
           this.init();
        }
    }
</script>

<style>
    .el-date-editor{
        width: 100% !important;
    }
</style>